import { render } from "./DepartmentComponent.vue?vue&type=template&id=07c26484"
import script from "./DepartmentComponent.vue?vue&type=script&lang=js"
export * from "./DepartmentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__